// extracted by mini-css-extract-plugin
var _1 = "has-icon__Egs9b";
var _2 = "link__YEb9O";
export { _1 as "has-icon", _2 as "link" }
